import React from 'react';
import _ from 'lodash';

import UsersApi from '../services/users/UsersApi';
import UsersService from '../services/users/UsersService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import CompanyBranchService from '../services/CompanyBranches';

import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';
import {
  ENV_VARS,
  REQUEST_PARAMS,
  USER_ROLES,
  ZENDESK_LINK_IDS,
} from '../utilities/constants';
import { getZendeskArticleUrl } from '../utilities/commonUtil';

import DropdownSelector from './dropdowns/DropdownSelector';
import {
  HEAD_OFFICE_OPTION,
  PartnerCompanyBranchDropdown,
} from './PartnerCompanyBranchDropdown';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListSubHeader,
} from './CommonFormComponents';
import { TrashIcon } from './icons/TrashIcon';
import { CcusDescription } from './CcusBase';

const REACT_APP_ZENDESK_URL = ENV_VARS.REACT_APP_ZENDESK_URL;

export const CcusUserDropdown = ({
  userValue,
  listUsers,
  setValueBranch,
  setValueUser,
  addUserInfo,
  deleteUserInfo,
  isRolePartner,
  companyUserEdit,
  isValidateSelect,
  defaultParams,
  agencyInfo,
  isAgency,
  isAddition,
  agentSelfFlag,
  setAgentSelfFlag,
  userName,
  userId,
  userCompanyName,
  deleteAllAgencyUsers,
}) => {
  const newArray = _.filter(listUsers, user => {
    return user.user_id === null;
  });
  const checkListUsers = _.isEqual(_.size(newArray), _.size(listUsers));
  const filteredUsers = _.filter(listUsers, user => {
    // Buildeeユーザー一覧の表示処理
    if (!_.has(user, 'agency_company_id')) {
      // 新しいユーザー行を追加する場合(agency_company_idが存在しない)
      return user;
    } else {
      // 代行先の連携ユーザー一覧の場合、プルダウン一覧から代行元（agency_company_id!=null）のユーザーを外す
      // 自社・代行元の連携ユーザー一覧の場合、代行元の連携ユーザーを別の一覧で表示するため「Buildeeユーザー」一覧から外す
      if (isAgency) {
        // 代行先連携ユーザー一覧
        return _.isNull(user.agency_company_id);
      } else {
        // 自社・代行元連携ユーザー一覧
        if (_.isNull(user.agency_company_id)) {
          return user;
        }
      }
    }
  });
  // 代行元の連携ユーザー
  const reducedUsers = _.reduce(
    listUsers,
    (list, user) => {
      if (
        _.has(user, 'agency_company_id') &&
        !_.isNull(user.agency_company_id)
      ) {
        if (
          !_.some(
            list,
            item => item.agency_company_id === user.agency_company_id
          )
        ) {
          list.push({
            agency_company_id: user.agency_company_id,
            agency_company_name: user.agency_company_name,
            users: [user],
          });
        } else {
          const listIndex = _.findIndex(
            list,
            item => item.agency_company_id === user.agency_company_id
          );
          list[listIndex]['users'].push(user);
        }
      }

      return list;
    },
    []
  );
  const classError =
    checkListUsers && !companyUserEdit && isValidateSelect
      ? 'error-msg form-list__item'
      : 'form-list__item';

  const paramsUserRolCode = () => {
    let param = {};
    if (isRolePartner) {
      param = { user_role_code: USER_ROLES.partner.id };
    }
    return param;
  };
  const renderDescription = () => {
    if (isRolePartner) {
      // 代行先の会社情報を見ている場合
      if (isAgency) {
        if (isAddition) {
          // その他の管理者情報の連携ユーザー設定の場合
          return (
            <CcusDescription>
              代行先のBuildeeユーザー、または現在代行操作中のユーザーご自身をCCUS管理者IDに紐付けます。
              <br />
              紐づけされたユーザーだけがCCUSから事業者情報、技能者情報の取得が可能となります。
              <br />※ その他管理者には代行元ユーザーを紐づけることはできません。
            </CcusDescription>
          );
        }
        return (
          <CcusDescription>
            代行先のBuildeeユーザー、または現在代行操作中のユーザーご自身をCCUS管理者IDに紐付けます。
            <br />
            紐づけされたユーザーだけがCCUSから事業者情報、技能者情報の取得が可能となります。
          </CcusDescription>
        );
      }
      return (
        <CcusDescription>
          会社内のBuildeeユーザーをCCUS管理者IDに紐付けます。
          <br />
          紐付けされたユーザーだけがCCUSから事業者情報、技能者情報の取得が可能となります。
        </CcusDescription>
      );
    }
    return (
      <CcusDescription>
        会社内のBuildeeユーザーをCCUS管理者IDに紐付けます。
        <br />
        紐付けされたユーザーだけがCCUSへの現場情報の登録および取得、施工体制の登録が可能となります。
      </CcusDescription>
    );
  };
  const isInUpstreamCcusFieldTrees = () => {
    return agencyInfo.in_upstream_ccus_field_trees === true;
  };
  return (
    <div className='CcusUserDropdown'>
      <FormList>
        <FormListSubHeader title='連携ユーザー情報' noMarginTop={true} />
        {renderDescription()}
        <div className='wrap-form'>
          <FormListItem
            label={
              companyUserEdit ? 'CCUS管理者ID（登録責任者）' : 'CCUS管理者ID'
            }
          >
            <FormElement>
              <div>{userValue}</div>
            </FormElement>
          </FormListItem>
          <FormListItem
            className={classError}
            label='Buildeeユーザー'
            required={!companyUserEdit}
          >
            <FormElement>
              <div className='multi-table__flex'>
                <div className='multi-table__dropdown'>
                  {_.map(filteredUsers, (item, index) => {
                    const {
                      company_branch_id,
                      partner_company_branch_id,
                      user_id,
                      user_name,
                      clearFlag,
                      company_branch_name,
                      partner_company_branch_name,
                    } = item;
                    const id = listUsers.indexOf(item);
                    return (
                      <div
                        className='multi-table__select'
                        key={`select-${index}-${company_branch_id}-${partner_company_branch_id}-${user_id}`}
                      >
                        {isRolePartner ? (
                          <PartnerCompanyBranchDropdown
                            selectedCompanyId={sessionStorage.getItem(
                              'companyCcusId'
                            )}
                            selectedPartnerCompanyBranchId={
                              _.isNull(partner_company_branch_id)
                                ? HEAD_OFFICE_OPTION.id
                                : partner_company_branch_id || ''
                            }
                            onSelect={value => setValueBranch(value, id)}
                            isOptional={true}
                            fixedOptions={[HEAD_OFFICE_OPTION]}
                            dropdownSelectStyle={{ width: '238px' }}
                            previewValue={
                              _.isNull(partner_company_branch_name)
                                ? HEAD_OFFICE_OPTION.name
                                : partner_company_branch_name
                            }
                          />
                        ) : (
                          <DropdownSelector
                            label='支店を選択'
                            selectorName='name'
                            api={params =>
                              CompanyBranchService.companyBranchList({
                                ...params,
                                ...defaultParams,
                              })
                            }
                            apiSearchKey='name'
                            selectedValues={
                              _.isNull(company_branch_id)
                                ? HEAD_OFFICE_OPTION.id
                                : String(company_branch_id) || ''
                            }
                            limit={
                              REQUEST_PARAMS.parentLimitPartnerCompanyBranchDropdown
                            }
                            keyName='name'
                            valueName='id'
                            apiBindDataKey='company_branches'
                            onSelect={(name, values) => {
                              setValueBranch(values, id);
                            }}
                            isOptional={true}
                            strictEqual={true}
                            reloadOptions={false}
                            dropdownSelectStyle={{ width: '238px' }}
                            fixedOptions={[HEAD_OFFICE_OPTION]}
                            selectedName={
                              _.isNull(company_branch_name)
                                ? HEAD_OFFICE_OPTION.name
                                : company_branch_name
                            }
                          />
                        )}
                        <div className='wrap-dropdown'>
                          <div className='wrap-dropdown__flex'>
                            <DropdownSelector
                              label='ユーザーを選択'
                              selectorName='user_id'
                              selectedValues={
                                isNullOrUndefinedOrEmptyStr(user_id) === false
                                  ? String(user_id)
                                  : []
                              }
                              selectedName={user_name}
                              keyName='fullname'
                              valueName='id'
                              api={params =>
                                UsersApi.fetchUserListByRole(
                                  UsersService.createSearchUserListByRole({
                                    ...params,
                                    isPrimeUser: !isRolePartner,
                                    block_flag: 0,
                                    company_id: SessionStorageService.getItem(
                                      'companyCcusId'
                                    ),
                                    ...paramsUserRolCode(),
                                  })
                                )
                              }
                              apiParams={
                                isRolePartner
                                  ? { partner_company_branch_id }
                                  : {
                                      company_branch_id: _.isNull(
                                        company_branch_id
                                      )
                                        ? -1
                                        : company_branch_id || '',
                                    }
                              }
                              apiSearchKey='fullname'
                              apiBindDataKey='user_lists'
                              clearFlag={clearFlag}
                              strictEqual={true}
                              dropdownSelectStyle={{ width: '238px' }}
                              onSelect={(name, values) => {
                                setValueUser(values, id);
                              }}
                            />
                            {_.size(listUsers) > 1 && (
                              <button
                                className='btn-icon--xs  form-list__element--btn_delete'
                                onClick={() => deleteUserInfo(id)}
                              >
                                <TrashIcon className='icon--2_4x form-list__trash-icon' />
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  {agentSelfFlag && (
                    <div className='multi-table__select'>
                      <div className='wrap-dropdown CcusUserDropdown__wrap'>
                        <div className='wrap-dropdown__flex'>
                          <div className='CcusUserDropdown__self-box'>
                            <span className='CcusUserDropdown__self-box-text'>
                              {userCompanyName}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className='wrap-dropdown CcusUserDropdown__wrap'>
                        <div className='wrap-dropdown__flex'>
                          <div className='CcusUserDropdown__self-box'>
                            <span className='CcusUserDropdown__self-box-text'>
                              {userName}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <button className='btn--sub' onClick={addUserInfo}>
                  連携ユーザーを追加
                </button>
                {isAgency && !isAddition && (
                  <React.Fragment>
                    <div
                      className={
                        isInUpstreamCcusFieldTrees()
                          ? 'CcusUserDropdown__checkbox'
                          : 'CcusUserDropdown__checkbox CcusUserDropdown__checkbox--disabled'
                      }
                    >
                      <label className='checkbox'>
                        <input
                          name='checkbox'
                          type='checkbox'
                          disabled={
                            !isInUpstreamCcusFieldTrees() && !agentSelfFlag
                          }
                          checked={agentSelfFlag}
                          onChange={e => setAgentSelfFlag(!agentSelfFlag)}
                        />
                        {isInUpstreamCcusFieldTrees() || agentSelfFlag ? (
                          <i className='i-square i-3x' />
                        ) : (
                          <i className='i-square-disabled i-3x' />
                        )}
                        自分を連携ユーザーに設定
                      </label>
                    </div>
                    {!isInUpstreamCcusFieldTrees() && (
                      <div className='CcusUserDropdown__checkbox-warning-message'>
                        自分を連携ユーザーに設定するための条件を満たしていません。
                        <br />
                        ご自身を代行先の連携ユーザーに設定するためには、施工体制のCCUS連携を行っているいずれかの現場で、代行先の会社があなたの会社の下位協力会社として登録されている必要があります。詳細は
                        <a
                          className='clickable-text'
                          href={`${getZendeskArticleUrl(
                            REACT_APP_ZENDESK_URL,
                            ZENDESK_LINK_IDS.CCUS_FIELD_TREES
                          )}`}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          こちら
                        </a>
                        をご確認ください。
                      </div>
                    )}
                  </React.Fragment>
                )}
              </div>
            </FormElement>
          </FormListItem>
          {!isAgency && (
            <FormListItem
              className={classError}
              label='代行元の連携ユーザー'
              required={!companyUserEdit}
            >
              <FormElement>
                <div className='multi-table__flex'>
                  <div className='multi-table__dropdown'>
                    {_.map(reducedUsers, company => {
                      return (
                        <div
                          className='multi-table__select CcusUserDropdown__agency-row'
                          key={`agency-${company.id}`}
                        >
                          <div className='wrap-dropdown CcusUserDropdown__wrap'>
                            <div className='wrap-dropdown__flex'>
                              <div className='CcusUserDropdown__self-box'>
                                <span className='CcusUserDropdown__self-box-text'>
                                  <span className='CcusUserEdit__agency-label' />
                                  {company.agency_company_name}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className='wrap-dropdown CcusUserDropdown__wrap'>
                            <div className='wrap-dropdown__flex'>
                              <div className='CcusUserDropdown__self-box CcusUserDropdown__self-box--centered'>
                                <span className='CcusUserDropdown__self-box-text'>
                                  {company.users.length}ユーザー
                                </span>
                              </div>
                              <button
                                className='btn-icon--xs  form-list__element--btn_delete'
                                onClick={() =>
                                  deleteAllAgencyUsers(
                                    company.agency_company_id
                                  )
                                }
                              >
                                <TrashIcon className='icon--2_4x form-list__trash-icon' />
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </FormElement>
            </FormListItem>
          )}
        </div>
      </FormList>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/CcusUserDropdown.jsx